import genderTypeEnum from "constants/genderTypeEnum"
import OptimizationStore from "modules/optimization/store/OptimizationStore"
import { Logger } from "sass"

export const toggleDisabledState = (formRef, fieldName, value, isAddAssuredSelect) => {

  if (isAddAssuredSelect) {
    if (fieldName === 'SELF') {
      formRef.$("secondary_members").$(fieldName).$("isSelected").value = false
    }
    formRef.$("secondary_members").$(fieldName).$("isSelected").value = value
    let memberID = formRef.$("secondary_members").$(fieldName).$("id").value
    OptimizationStore.setSecondaryLASelectdForAddAssured(memberID)
    const listOfValues = formRef.get().secondary_members.value
    let valueKeys = []
    for (const key in listOfValues) {
      valueKeys.push(key)
    }

    valueKeys.forEach((item) => {
      if (item !== fieldName) {
        formRef.$("secondary_members").$(item).$("isSelected").value = false
      }
    })
  } else {
    formRef.$("members").$(fieldName).$("isSelected").value = value
    OptimizationStore.setPrimaryLASelectedForAddAsured(fieldName);
    const listOfValues = formRef.get().members.value
    let valueKeys = []
    for (const key in listOfValues) {
      valueKeys.push(key)
    }

    valueKeys.forEach((item) => {
      if (item !== fieldName) {
        formRef.$("members").$(item).$("isSelected").value = false
      }
    })
  }
}


export const genderFunction = (gender) => {
  switch (gender) {
    case genderTypeEnum.MALE:
      return "M"
      break

    case genderTypeEnum.FEMALE:
      return "F"
      break

    default:
      return "O"
      break
  }
}

export const addIdToOptimisationStore = (formController, onHide) => {

  formController.validate({ showErrors: true })
    .then(({ isValid }) => {
      if (isValid) {

        const formFieldValuesArray = formController.get().members.value
        for (const key in formFieldValuesArray) {
          if (formFieldValuesArray[key].isSelected === true) {
            const id = formFieldValuesArray[key].id
            OptimizationStore.setSelectedMemberId(id)
          }
        }
        onHide()
      }
    });
}


export const showRelationWhenNoName = (salutation, fName, mName, lName, relation) => {
  console.log("member relation", relation)
  let fullName = `${fName}${mName}${lName}`

  if (fullName.length == 0) {
    return <span className="font-weight-bold">
      [{relation == "GRAND MOTHER" ? "MOTHER" : relation == "GRAND FATHER" ? "FATHER" : relation}]
    </span>
  } else {
    return <span className="ml-2 font-weight-light">
      {`${salutation} ${fName} ${mName} ${lName} [${relation == "GRAND MOTHER" ? "MOTHER" : relation == "GRAND FATHER" ? "FATHER" : relation}]`}
    </span>
  }
}